<script setup lang="ts">
import AuthTitle from './components/auth-title.vue';
import GoogleButton from './components/google-button.vue';
import PrivacyPolicyButton from './components/privacy-policy-button.vue';
import TermsOfServiceButton from './components/terms-of-service-button.vue';
</script>

<template>
  <div class="flex items-center justify-center min-h-[100dvh] p-4 min-w-screen">
    <main class="flex flex-col gap-4">
      <AuthTitle />
      <UiCard class="max-w-sm mx-auto">
        <UiCardHeader>
          <UiCardTitle class="text-xl"> Create Account </UiCardTitle>
          <UiCardDescription>
            Sign up with your Google account to access RingCentral Call Analysis Portal.
            <div class="mt-1">
              Already have an account?
              <UiButton
                variant="link"
                class="px-0 text-muted-foreground"
                @click="$router.push('/auth/sign-in')"
              >
                Sign In
              </UiButton>
            </div>
          </UiCardDescription>
        </UiCardHeader>
        <UiCardContent>
          <div class="flex flex-col items-center justify-center py-4">
            <div class="mb-6">
              <img src="/logo.svg" alt="RingCentral Logo" class="h-12 mx-auto mb-6" />
            </div>
            <GoogleButton class="w-full max-w-xs" />
          </div>

          <UiCardDescription class="text-center text-xs mt-6">
            By signing up, you agree to our
            <TermsOfServiceButton />
            and
            <PrivacyPolicyButton />
          </UiCardDescription>
        </UiCardContent>
      </UiCard>
    </main>
  </div>
</template>
